import Papa from "papaparse";
import { navImageMap } from "../data/portfolioData";

const SHEET_URLS = {
  profile:
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQSzT6g_m9OehMEdbCTCvILQm-qxdwdbB8YQ3oFidWn8K_HadHLJJv0mtZ6znQGrfcW7nAu9PRZZmQJ/pub?gid=0&single=true&output=csv",
  navItems:
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQSzT6g_m9OehMEdbCTCvILQm-qxdwdbB8YQ3oFidWn8K_HadHLJJv0mtZ6znQGrfcW7nAu9PRZZmQJ/pub?gid=1509733491&single=true&output=csv",
  workItems:
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQSzT6g_m9OehMEdbCTCvILQm-qxdwdbB8YQ3oFidWn8K_HadHLJJv0mtZ6znQGrfcW7nAu9PRZZmQJ/pub?gid=474046777&single=true&output=csv",
  workItemsTimeline:
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQSzT6g_m9OehMEdbCTCvILQm-qxdwdbB8YQ3oFidWn8K_HadHLJJv0mtZ6znQGrfcW7nAu9PRZZmQJ/pub?gid=2086875002&single=true&output=csv",
  games:
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQSzT6g_m9OehMEdbCTCvILQm-qxdwdbB8YQ3oFidWn8K_HadHLJJv0mtZ6znQGrfcW7nAu9PRZZmQJ/pub?gid=2035992583&single=true&output=csv",
  aiItems:
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vQSzT6g_m9OehMEdbCTCvILQm-qxdwdbB8YQ3oFidWn8K_HadHLJJv0mtZ6znQGrfcW7nAu9PRZZmQJ/pub?gid=1238890076&single=true&output=csv",
};

const fetchCsv = async (url) => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error("Failed to fetch Google Sheet CSV");
  }

  const csvText = await response.text();

  const result = Papa.parse(csvText, {
    header: true,
    skipEmptyLines: true,
  });

  return result.data;
};

export const fetchPortfolioDataFromSheet = async () => {
  const [profileRows, navItems, workItems, workItemsTimeline, games, aiItems] =
    await Promise.all([
      fetchCsv(SHEET_URLS.profile),
      fetchCsv(SHEET_URLS.navItems),
      fetchCsv(SHEET_URLS.workItems),
      fetchCsv(SHEET_URLS.workItemsTimeline),
      fetchCsv(SHEET_URLS.games),
      fetchCsv(SHEET_URLS.aiItems),
    ]);

  const profile = { educations: [], certificates: [] };
  let currentEdu = {};
  let currentCerti = {};

  profileRows.forEach((row) => {
    if (!row.key) return;

    const key = row.key.trim();
    const value = row.value ? row.value.trim() : "";

    if (key === "education") {
      currentEdu.title = value;
    } else if (key === "eduTime") {
      currentEdu.time = value;
      currentEdu.id = crypto.randomUUID ? crypto.randomUUID() : Date.now() + Math.random();
      profile.educations.push({ ...currentEdu });
      currentEdu = {};
    } else if (key === "certificate") {
      currentCerti.url = value;
    } else if (key === "certificateName") {
      currentCerti.name = value;
    } else {
      profile[key] = value;
    }
    if (currentCerti.name && currentCerti.url) {
      currentCerti.id = crypto.randomUUID ? crypto.randomUUID() : Date.now() + Math.random();
      profile.certificates.push({ ...currentCerti });
      currentCerti = {}; // Reset for the next certificate pair
    }
  });

  const navItemsWithImages = navItems.map((item) => ({
    ...item,
    image: navImageMap[item.path] || navImageMap["/"],
  }));

  return {
    profile,
    navItems: navItemsWithImages,
    workItems,
    workItemsTimeline,
    games,
    aiItems,
  };
};